export default __webpack_public_path__ + "static/media/signal.7de35485.svg";